<div class="container container-full-page">
  <div class="public-header">
    <ng-container *ngIf="!isSignedIn">
      <a [routerLink]="['/']">
        <div class="back-btn">
          <fa-icon [icon]="faChevronLeft"></fa-icon> back
        </div>
      </a>
    </ng-container>

    <ng-container *ngIf="isSignedIn">
      <a [routerLink]="['/authentication/logout']" [state]='{ local: true }'
      title="Logout">
        <div class="back-btn">
          <fa-icon [icon]="faSignOutAlt" class="me-1"></fa-icon> Logout
        </div>
      </a>
    </ng-container>

      <a [routerLink]="['/']">
        <img srcset="
        /assets/knight-frank.png 1x,
        /assets/knight-frank@2x.png 2x,
        /assets/knight-frank@3x.png 3x
        " alt="Knight Frank" class="logo logo-kf">

        <img srcset="
        /assets/vision-insights.png 1x,
        /assets/vision-insights@2x.png 2x,
        /assets/vision-insights@3x.png 3x
        " alt="Vision Insights" class="logo logo-vs">
      </a>
  </div>

  <router-outlet></router-outlet>
</div>

